import styled from 'styled-components';
import { Layout } from 'antd';
import { COLORS } from 'theme';

export const Wrapper = styled(Layout.Header)`
  background: ${COLORS.darkBlue};
  height: 46px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 0 0;
`;
